function stringifyLinesOfCoverageWithDictionary(linesOfCoverage, locDefinitionsDictionary) {
  return linesOfCoverage.map(loc => {
    var _locDefinitionsDictio;

    return `${((_locDefinitionsDictio = locDefinitionsDictionary[loc.type]) === null || _locDefinitionsDictio === void 0 ? void 0 : _locDefinitionsDictio.readableName) ?? ''}${loc.displayName ? ` - ${loc.displayName}` : ''}`;
  }).join(', ') || '-';
}
function stringifyLinesOfCoverage(linesOfCoverage) {
  return linesOfCoverage.map(loc => {
    var _loc$definition;

    return `${((_loc$definition = loc.definition) === null || _loc$definition === void 0 ? void 0 : _loc$definition.readableName) ?? ''}${loc.displayName ? ` - ${loc.displayName}` : ''}`;
  }).join(', ') || '-';
}
function stringifyLineOfCoverage(lineOfCoverage, locDefinitionsDictionary) {
  var _locDefinitionsDictio2;

  const readableName = (_locDefinitionsDictio2 = locDefinitionsDictionary[lineOfCoverage.type]) === null || _locDefinitionsDictio2 === void 0 ? void 0 : _locDefinitionsDictio2.readableName;
  return [readableName, lineOfCoverage.displayName].filter(value => !!value).join(' - ');
}
let LineOfCoverageStatus;

(function (LineOfCoverageStatus) {
  LineOfCoverageStatus["ACTIVE"] = "ACTIVE";
  LineOfCoverageStatus["UPCOMING"] = "UPCOMING";
  LineOfCoverageStatus["EXPIRED"] = "EXPIRED";
})(LineOfCoverageStatus || (LineOfCoverageStatus = {}));

export { LineOfCoverageStatus as L, stringifyLineOfCoverage as a, stringifyLinesOfCoverage as b, stringifyLinesOfCoverageWithDictionary as s };
